<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <actions-vo :saisit_en_ligne="saisit_en_ligne"></actions-vo>
    </template>
    <div v-loading="loadingStatus"
         :element-loading-text="$t('portals.list.chargementDonnees')">
      <dialogs-vo
        :modal-show-models="modalShowModels"
        :modal-confirmed-delete-list="modalConfirmedDeleteList"
        :modal-delete="modalDelete"
        :modal-duplicate="modalDuplicate"
        :modal-use-model="modalUseModel"
        :close-modal-confirmed-delete-list="modalConfirmedDeleteList = false"
        :selected="selected"
        :close-show-models="modalShowModels = false"
        :titre-modal-confirmed-delete-list="titreModalConfirmedDeleteList"
        :modal-confirmed-change-contact-list="modalConfirmedChangeContactList"></dialogs-vo>

      <el-form @submit.prevent.native="fetchList" label-position="top">
        <PostsListVoSearch
            :filters="filters"
            :marque-vehicule="marqueVehicule"
            :modele-vehicule="modeleVehicule"
            v-on:charger-liste-modele="chargerListeModele($event)"
          ></PostsListVoSearch>

        <!--Affichage Vignette-->
        <cards-list-vo v-if="affichageReduit === false" :affichageReduit="affichageReduit"
                       :limits="limits"
                       :total="results.total"
                       :page="page"
                       :limit="limit"
                       :sort="sort"
                       :sortProperties="sortProperties"
                       :results="results"
                       v-on:load-data="fetchList()"
                       v-on:switch-published="onSwitchPublished($event)"
                       v-on:do-select="doSelect($event)"
                       v-on:change-contacts="changeContacts($event)"
                       v-on:open-delete-modal="openDeleteModal($event)"
                       v-on:open-use-model-modal="openUseModelModal($event)"
                       v-on:open-duplicate-modal="openDuplicateModal($event)"
                       v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
                       v-on:affichage-reduit="gestionAffichageReduit($event)"
                       v-on:exporter="exporter($event)"
                       v-on:diffuse-later="$emit('diffuse-later',$event)"></cards-list-vo>

        <!--Affichage Liste-->
        <div v-else>
          <table-list-vo
              :affichageReduit="affichageReduit"
              :limits="limits"
              :total="results.total"
              :page="page"
              :limit="limit"
              :sort="sort"
              :sortProperties="sortProperties"
              :results="results"
              v-on:load-data="fetchList()"
              v-on:switch-published="onSwitchPublished($event)"
              v-on:do-select="doSelect($event)"
              v-on:change-contacts="changeContacts($event)"
              v-on:open-delete-modal="openDeleteModal($event)"
              v-on:open-use-model-modal="openUseModelModal($event)"
              v-on:open-duplicate-modal="openDuplicateModal($event)"
              v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
              v-on:affichage-reduit="gestionAffichageReduit($event)"
              v-on:exporter="exporter($event)"
              v-on:diffuse-later="$emit('diffuse-later',$event)"
            ></table-list-vo>
        </div>
      </el-form>
    </div>
  </ubi-page-container>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getDefinitionDonneeListeeByCode,
  exportXlsPosts, setPostPublishedState,
  deletePost,
  deleteAllPosts, getModelsOfBrand, getBrandsOfObjectType
} from '@/services/posts'
import PostsListVoSearch from '@/pages/posts/List/Search/PostsListVoSearch'
import DialogsVo from '@/pages/posts/components/PostsList/DialogsVo'
import ActionsVo from '@/pages/posts/components/PostsList/ActionsVo'
import CardsListVo from '@/pages/posts/components/PostsList/CardsListVo'
import TableListVo from '@/pages/posts/components/PostsList/TableListVo'

import { getUsers } from '@/services/users'

export default {
  name: 'PostsList',
  components: { ActionsVo, DialogsVo, PostsListVoSearch, CardsListVo, TableListVo },
  data () {
    return {
      modeleVehicule: [],
      marqueVehicule: [],
      ddList: [],
      loading: false,
      limits: [10, 20, 50],
      selected: [],
      sortProperties: {
        '-DC': this.$t('general.sort.decreaseDate'),
        DC: this.$t('general.sort.increaseDate'),
        R: this.$t('general.sort.reference'),
        T: this.$t('general.sort.title')
      },
      filters: [
        { value: 'allAds', label: this.$t('general.filters.allAds') },
        { value: 'enable', label: this.$t('general.filters.activeAds') },
        { value: 'disabled', label: this.$t('general.filters.inactiveOrDraftAds') },
        { value: 'withoutPictures', label: this.$t('general.filters.withoutPictures') },
        { value: 'modeles', label: this.$t('general.filters.modelAds') }
      ],
      referenceDuplication: null,
      modalDuplicate: false,
      modalUseModel: false,
      modalShowModels: false,
      modalDelete: false,
      modalConfirmedDeleteList: false,
      modalConfirmedChangeContactList: false,
      titreModalConfirmedDeleteList: '',
      deleteId: null,
      affichageReduit: false,
      allPostSelected: [],
      users: [],
      contacts: []
    }
  },
  computed: {
    ...mapState('postsVo', ['filter', 'results', 'loadingStatus', 'annonceFlux']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getPickerOptionsShortcuts']),
    ...mapGetters(['saisit_en_ligne']),
    userFilter () {
      return this.filter.user
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.filter.page = value
        this.fetchList()
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async beforeMount () {
    if (this.$route.params.reset) {
      this.resetFilter()
    }
    this.marqueVehicule = await getBrandsOfObjectType('11000', true) // 11000 by default
    let codes = [
      'marque',
      'modele'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    this.ddList = await getDefinitionDonneeListeeByCode({ codes: codes })

    if (this.possedeContactManager === false) {
      delete this.sortProperties.contact
    }
    this.affichageReduit = this.$store.getters['donnees/getAffichageReduit']
    if (this.hasMultiAccounts) {
      this.users = (await getUsers({ active: true, pagination: false, roles: '!ROLE_CONTACT' })).list
    }
    const contacts = await getUsers()
    if (contacts) {
      this.contacts = contacts.list
    }
  },
  watch: {
    userFilter: function (user) {
      if (user) {
        const userMatch = this.users.find(x => x.id === this.filter.user)
        if (userMatch.identifierCode && userMatch.identifierValue) {
          this.addFilter({
            dataValues: {
              USER_DATA_CODE: userMatch.identifierCode,
              USER_DATA_VALUE: userMatch.identifierValue
            }
          })
        } else {
          this.addFilter({ dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null } })
        }
      } else {
        this.addFilter({ dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null } })
      }
    },
  },
  methods: {
    ...mapMutations('postsVo', [
      'setPage',
      'setLimit',
      'setSort',
      'setStock',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setCurrentId',
      'setLoadingStatus',
      'setModalDuplicate',
      'setModalConfirmedDeleteList',
      'setSelection',
      'setModalConfirmedChangeContactList'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    applyFilter (payload) {
      this.doFilter(payload)
    },
    async chargerListeModele (brand) {
      this.modeleVehicule = await getModelsOfBrand(brand)
    },
    getChoices (code) {
      if (!this.ddList.length) return []
      const dd = this.ddList.find(x => x.code === code.toUpperCase())
      if (dd) {
        return dd.values
      }
      return []
    },
    changeContacts () {
      this.setModalConfirmedChangeContactList(true)
    },
    closeChangeContacts () {
      this.modalConfirmedChangeContactList = false
    },
    async fetchList () {
      this.$store.dispatch('postsVo/loadPosts')
      this.scrollWin()
    },
    scrollWin () {
      window.scrollTo(500, 0)
    },
    async exporter () {
      this.setLoadingStatus(true)
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })
      const res = await exportXlsPosts(this.filter, strSelectedIds, false, this.$t('posts.list.filenameExportAds'))
      this.$message(res)
      this.setLoadingStatus(false)
    },
    async doSelect (type) {
      switch (type) {
        case '*':
          this.selected = []
          const tmpSelection = this.results.list.map(({ id }) => id)
          this.selected = this.selected.concat(tmpSelection)
          break
      }
    },
    openDuplicateModal (id) {
      this.eventAnalytics('utiliser_modele')
      this.setCurrentId(id)
      this.setModalDuplicate(true)
    },
    openUseModelModal (id) {
      this.setCurrentId(id)
      this.modalUseModel = true
    },
    async supprimer (id) {
      const callDelete = await deletePost(id)
      if (callDelete.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.setLoadingStatus(false)
        this.modalDelete = false
        return false
      }
      const type_notif = 'success'
      const message_notif = this.$t('posts.dialog.deleteNotification')
      this.$message({
        message: message_notif,
        type: type_notif
      })
      this.fetchList()
      this.selected = []
      this.modalDelete = false
      this.modalConfirmedDeleteList = false
    },
    async supprimerAll (annonces) {
      const callDelete = await deleteAllPosts(annonces)
      const type_notif = 'success'
      const message_notif = this.$t('validator.addDelete')
      this.$message({
        message: message_notif,
        type: type_notif
      })
      this.fetchList()
      this.selected = []
      this.modalConfirmedDeleteList = false
    },
    openDeleteModal (id) {
      this.eventAnalytics('supprimer_annonce')
      this.deleteId = id
      this.modalDelete = true
    },
    async onSwitchPublished (id, state) {
      this.setLoadingStatus(true)
      const selectedIds = []
      this.selected.forEach(function (idSelected) {
        selectedIds.push(idSelected)
      })
      const changedState = await (setPostPublishedState(selectedIds, id, 'SAISIE_VO'))
      setTimeout(() => this.fetchList(), 1500)
      if (changedState.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.setLoadingStatus(false)
        return false
      }
      this.fetchList()
      this.setLoadingStatus(false)
      if (this.affichageReduit) {
        this.selected = []
      }
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.openDeleteModal(command.id)
      } else if (command.name === 'useModel') {
        this.openUseModelModal(command.id)
      } else if (command.name === 'duplicate') {
        this.openDuplicateModal(command.id)
      } else if (command.name === 'edit') {
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({ name: 'attendance-report-post', params: { post: command.id } })
      } else if (command.name === 'diffuseLater') {
        this.$emit('diffuseLater', { id: command.id, diffuseLaterDate: command.diffuseLaterDate })
      } else if (command.name === 'private-note') {
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gestionAffichageReduit (rep) {
      this.affichageReduit = rep
      this.$store.commit('donnees/SET_AFFICHAGE_REDUIT', this.affichageReduit)
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
        // this.$refs.tablePortalsList.clearSelection();
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    activationModalConfirmedDeleteList (payload) {
      if (payload.quantite == 1) {
        this.titreModalConfirmedDeleteList = 'Etes-vous sûr de vouloir supprimer votre annonce ?'
      } else {
        this.titreModalConfirmedDeleteList = 'Etes-vous sûr de vouloir supprimer vos ' + payload.quantite + ' annonces ?'
      }
      this.setSelection(payload.selection)
      this.setModalConfirmedDeleteList(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/theme/_bootstrap.scss";

  .el-loading-spinner {
    top: 10% !important;
  }

  .PostsList {
    &-selection {
      @extend .mb-5;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .PostItem {
      &-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &-reference {
        @extend .font-secondary;
        text-transform: uppercase;
      }

      &-location,
      &-price,
      &-date {
        font-size: $font-size-lg;
      }

      &-price {
        float: left;
      }

      &-date {
        float: right;
      }

      &-actions {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &-contacts {
        @extend .font-secondary;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      &-contacts-value {
        font-size: $font-size-lg-alt;
        line-height: $font-size-lg-alt;
        font-weight: $font-weight-bold;
      }

      &-contacts-label {
        text-transform: uppercase;
        font-size: $font-size-sm-alt;
      }
    }

    @include media-breakpoint-down(md) {
      &-selection {
        flex-direction: column;
        align-items: flex-start;
      }
      &-export {
        align-self: flex-end;
      }
    }

    @include media-breakpoint-down(sm) {
      &-item {
        margin-bottom: map-get($spacers, 3) !important;
      }

      .PostItem {
        &-actions {
          flex-direction: column;

          .PostItem-buttons {
            margin-bottom: map-get($spacers, 3);
          }
        }

        &-contacts {
          align-self: flex-end;
        }
      }
    }
  }
  .group-btn {
    display: inline!important;
  }
</style>
